import React, { useContext, useState } from 'react';
import { Award } from 'lucide-react';
import AuthContext from '../contexts/AuthContext';
import MeritLeaderboard from './MeritLeaderboard';

const MeritDisplay = () => {
  const { user } = useContext(AuthContext);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  
  if (!user || typeof user.merit === 'undefined') {
    return null;
  }

  // Function to get merit color based on merit score
  const getMeritColor = (merit) => {
    if (merit >= 1000) return 'text-purple-600 dark:text-purple-400';
    if (merit >= 500) return 'text-blue-600 dark:text-blue-400';
    if (merit >= 250) return 'text-green-600 dark:text-green-400';
    if (merit >= 100) return 'text-yellow-600 dark:text-yellow-400';
    if (merit >= 50) return 'text-orange-600 dark:text-orange-400';
    return 'text-gray-600 dark:text-gray-400';
  };

  const handleClick = () => {
    setShowLeaderboard(true);
  };

  return (
    <>
      <button 
        onClick={handleClick}
        className="flex items-center hover:opacity-80 transition-opacity"
        title="View Merit Leaderboard"
      >
        <Award className={`h-5 w-5 ${getMeritColor(user.merit)} mr-1`} />
        <span className={`text-sm font-medium ${getMeritColor(user.merit)}`}>
          {user.merit}
        </span>
      </button>
      
      <MeritLeaderboard 
        isOpen={showLeaderboard}
        onClose={() => setShowLeaderboard(false)}
      />
    </>
  );
};

export default MeritDisplay;